export const HEADER = "HEADER";
export const CLEAR = "CLEAR";
export const REQUEST = 'REQUEST';
export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';
export const LOGIN_USER_INFO='LOGIN_USER_INFO';
export const LOGIN_AUTH_TOKEN='LOGIN_AUTH_TOKEN';
export const LOGIN_CLEAR ='LOGIN_CLEAR';
export const ACCESS_SECURITY = 'ACCESS_SECURITY';

export const LANG_CODE=sessionStorage.getItem('LANG_CODE1');
export const USER_ID=sessionStorage.getItem('USER_ID1');
export const SITE_ID=sessionStorage.getItem('SITE_ID1');
export const CHANNEL_ID='101-00000015';
export const AUTH_TOKEN=sessionStorage.getItem('AUTH_TOKEN1');